import { render, staticRenderFns } from "./password1.vue?vue&type=template&id=f5241dc8&"
import script from "./password1.vue?vue&type=script&lang=js&"
export * from "./password1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports